var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:['page-list-item', {
		'is-active': _vm.data.isActive,
		'has-child': _vm.data.hasChild
	}],on:{"click":_vm.handleSelectItem}},[_c('p',{staticClass:"page-list-item-name typo-body-2"},[_vm._v(" "+_vm._s(_vm.data.name)+" ")]),(!_vm.isContactUsPage)?_c('router-link',{staticClass:"page-list-item-edit-button typo-helper-text",attrs:{"to":{
			name: 'PageEdit',
			params: { id: _vm.data.id }
		}},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" Edit ")]):_vm._e(),(_vm.data.hasChild)?_c('FontAwesomeIcon',{staticClass:"page-list-item-arrow",attrs:{"icon":['fas', 'chevron-right']}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }